import React from 'react';

const FieldMessage = ({ color, message }) => (
    <div style={{ color }}>
      <small>{message}</small>
    </div>
  )

export default FieldMessage


// WEBPACK FOOTER //
// ./src/components/common/FieldMessage.js